import { styled } from '@mui/material';

export const WhyChooseStyledTableAligner = styled('div')(({}) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
}));

export const WhyChooseStyledTableWrapper = styled('div')(({ theme }) => ({
  width: '100%',
  ...theme.mixins.gradientTable('large'),
}));
